import { useState } from "react"
import { PlusIcon } from "lucide-react"
import { useTranslations } from "next-intl"

import { UserData } from "@/lib/intershop/interfaces/user/user"
import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { Button } from "@/components/ui/components/button"
import AddressEditModal from "@/components/common/addresses/AddressEditModal"

interface AddAddressButtonProps {
  customer: any
  user: any
  onAdd: (address: ExtendedAddressRO, user: UserData) => void
}

export default function AddAddressButton({ customer, user, onAdd }: AddAddressButtonProps) {
  const t = useTranslations("storefront")
  const [modalVisible, setModalVisible] = useState(false)
  const [addressToAdd, setAddressToAdd] = useState<ExtendedAddressRO | null>(null)

  const handleAddClick = () => {
    setAddressToAdd({
      id: "",
      name: "",
      type: "",
      urn: "",
      externalID: "",
      externalUrn: "",
      addressName: "",
      taxationID: "",
      title: "",
      aristocraticTitle: "",
      jobTitle: "",
      honorific: "",
      firstName: "",
      secondName: "",
      lastName: "",
      secondLastName: "",
      companyName1: "",
      companyName2: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      postBox: "",
      mainDivision: "",
      mainDivisionName: "",
      subDivision: "",
      subDivisionName: "",
      postalCode: "",
      email: "",
      phoneMobile: "",
      phoneHome: "",
      phoneBusiness: "",
      phoneBusinessDirect: "",
      country: "",
      countryCode: "",
      city: "",
      fax: "",
      shipFromAddress: false,
      serviceToAddress: false,
      installToAddress: false,
      invoiceToAddress: false,
      shipToAddress: false,
    } as ExtendedAddressRO)
    setModalVisible(true)
  }

  const handleSave = (newAddress: ExtendedAddressRO, newUser: UserData) => {
    onAdd(newAddress, newUser)
    setModalVisible(false)
  }

  return (
    <>
      <Button size={"smNoGrow"} variant={"default"} className="text-white" onClick={handleAddClick}>
        <PlusIcon strokeWidth={1} className="inline" />
        <span className="ml-2">{t("forms.edit_address_form.add")}</span>
      </Button>
      <AddressEditModal
        visible={modalVisible}
        address={addressToAdd}
        customer={customer}
        user={user}
        mode="add"
        onCancel={() => setModalVisible(false)}
        onSave={handleSave}
      />
    </>
  )
}
